import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import PageHeader from '../components/PageHeader';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/common-page.css';
import CeremonyCard from '../components/CeremonyCard';
import EmptyState from '../components/EmptyState';
import VillageIllustration from '../components/VillageIllustration';
import axiosInstance from '../services/axios';
import birthdayImage from '../assets/images/birthday.png';

const BirthdayWishes = () => {
  const { i18n } = useTranslation();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const content = {
    en: {
      homepage: 'Homepage',
      title: 'Birthday Wishes',
      footerAlt: 'Footer Image'
    },
    mr: {
      homepage: 'मुख्यपृष्ठ',
      title: 'आपल्या गावचा कट्टा',
      footerAlt: 'तळ चित्र'
    }
  };

  const currentContent = content[i18n.language] || content.mr;

  useEffect(() => {
    const fetchBirthdayWishes = async () => {
      try {
        setLoading(true);
        const language = i18n.language === 'mr' ? 'Marathi' : 'English';
        const response = await axiosInstance.get('/birthday-wishes/', {
          params: { language }
        });

        const data = response.data;
        console.log('Birthday Wishes API response:', data);

        if (data && data.length > 0) {
          const mapped = data.map(item => ({
            id: item.id,
            imgSrc: item.cover_image || birthdayImage,
            title: item.title,
            description: item.description || '',
            birthDate: item.birthday_date || '',
            detailLink: `/birthday-wishes/${item.id}`,
            label: i18n.language === 'en' ? 'Share on WhatsApp' : 'व्हॉट्सअप करा'
          }));
          setList(mapped);
        }
      } catch (err) {
        console.error('Error fetching birthday wishes:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBirthdayWishes();
  }, [i18n.language]);

  return (
    <div className="bg-image-section">
      <div className="flex flex-col gap-4 section-padding">
        <PageHeader
          breadcrumb={[
            <Link key="home" to="/">{currentContent.homepage}</Link>,
            <span key="birthday">{currentContent.title}</span>
          ]}
          title={currentContent.title}
        />

        {/* Birthday cards grid */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Spin size="large" />
          </div>
        ) : list.length === 0 ? (
          <div style={{ padding: '50px 0' }}>
            <EmptyState description={i18n.language === 'mr' ? 'डेटा लवकरच उपलब्ध होईल' : 'Data will be available soon'} />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {list.map(item => (
              <CeremonyCard
                key={item.id}
                imgSrc={item.imgSrc}
                title={item.title}
                description={item.description}
                birthDate={item.birthDate}
                label={item.label}
                shareLink={item.shareLink}
                detailLink={item.detailLink}
                className=""
              />
            ))}
          </div>
        )}
      </div>

      <VillageIllustration />
    </div>
  );
};

export default BirthdayWishes;
